<div class="{{ className }}">
  <div class="{{ className }}__header">
    <h2 class="{{ className }}__title">Remove {{ data.appName }}</h2>
    <button
      (click)="onClose()"
      [attr.aria-label]="'Close'"
      class="{{ className }}__close"
      mat-icon-button
      type="button">
      <mat-icon class="material-icons-outline">close</mat-icon>
    </button>
  </div>

  <div class="{{ className }}__body">
    <p class="{{ className }}__text">{{ data.appName }}{{ labels.dialogBody }}</p>
    <p class="{{ className }}__note">{{ labels.dialogNote }}</p>
  </div>

  <div class="{{ className }}__footer">
    <button (click)="onRemove()" class="{{ className }}__remove" type="button">
      {{ labels.removeFromLibrary }}
    </button>
  </div>
</div>
